var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Icon',_vm._b({staticClass:"cipher-logo-indicator",class:{ infinite: _vm.infinite, reveal: _vm.reveal, white: _vm.white, hide: !_vm.reveal },attrs:{"name":"cipher"}},'Icon',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }